import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_video-forge-417/artifacts/8amlg66h_Logo%20futuriste%20de%20ViralSynth.com.png";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="privacy-page">
      <header className="border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="ViralSynth" className="w-36 h-auto" />
          </Link>
          <Link to="/" className="text-sm text-white/60 hover:text-white flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-8">
          <Shield className="w-8 h-8 text-[#FF3300]" />
          <h1 className="font-heading text-3xl font-medium">Politique de Confidentialite</h1>
        </div>
        <p className="text-sm text-white/40 mb-8">Derniere mise a jour : 24 avril 2026</p>

        <div className="prose prose-invert max-w-none space-y-6 text-white/70 text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-xl text-white mb-3">1. Introduction</h2>
            <p>ViralSynth ("nous", "notre", "nos") s'engage a proteger la vie privee de ses utilisateurs. Cette politique decrit quelles donnees nous collectons, comment nous les utilisons, et vos droits.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">2. Donnees collectees</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-white">Donnees de compte</strong> : email, nom, photo de profil (via Google OAuth ou inscription email).</li>
              <li><strong className="text-white">Contenu genere</strong> : projets, descriptions, scripts, images, videos.</li>
              <li><strong className="text-white">Tokens tiers</strong> : tokens OAuth YouTube, Instagram, X, TikTok (chiffres AES-256).</li>
              <li><strong className="text-white">Donnees de paiement</strong> : gerees par Stripe (nous ne stockons aucune donnee de carte).</li>
              <li><strong className="text-white">Donnees d'usage</strong> : nombre de videos generees, publications effectuees.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">3. Utilisation des donnees</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fournir le service de generation et publication automatique de videos.</li>
              <li>Gerer votre abonnement et vos credits.</li>
              <li>Publier des videos sur vos comptes sociaux uniquement avec votre consentement explicite.</li>
              <li>Ameliorer le service (statistiques anonymisees uniquement).</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">4. Partage avec des tiers</h2>
            <p>Nous partageons UNIQUEMENT les donnees necessaires avec :</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li><strong className="text-white">OpenAI / Gemini / Claude</strong> : pour la generation de scripts (via cles API securisees).</li>
              <li><strong className="text-white">ElevenLabs / HeyGen</strong> : pour la synthese vocale et avatar.</li>
              <li><strong className="text-white">Google (YouTube), Meta (Instagram/Facebook), X, TikTok</strong> : uniquement pour publier vos videos sur vos comptes.</li>
              <li><strong className="text-white">Stripe</strong> : pour le traitement des paiements.</li>
              <li><strong className="text-white">SendGrid</strong> : pour l'envoi d'emails transactionnels.</li>
            </ul>
            <p className="mt-3">Aucune vente ou location de donnees a des tiers.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">5. Securite</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Chiffrement AES-256 pour tous les tokens tiers.</li>
              <li>Mots de passe hashes avec bcrypt.</li>
              <li>Sessions via cookies HttpOnly Secure.</li>
              <li>HTTPS obligatoire sur l'ensemble de la plateforme.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">6. Vos droits (RGPD)</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acces a vos donnees personnelles.</li>
              <li>Rectification.</li>
              <li>Suppression (droit a l'oubli).</li>
              <li>Portabilite.</li>
              <li>Opposition au traitement.</li>
            </ul>
            <p className="mt-3">Pour exercer ces droits : <a href="mailto:privacy@viralsynth.com" className="text-[#FF3300] hover:underline">privacy@viralsynth.com</a></p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">7. Revoquer l'acces aux comptes sociaux</h2>
            <p>Vous pouvez a tout moment deconnecter un compte social via la page "Comptes connectes" dans votre dashboard. La revocation est immediate et definitive cote ViralSynth.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">8. Cookies</h2>
            <p>Nous utilisons uniquement des cookies techniques necessaires (session). Aucun cookie publicitaire ou tiers.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">9. Conservation</h2>
            <p>Les donnees sont conservees tant que votre compte est actif. Apres suppression du compte, les donnees sont effacees sous 30 jours (hors obligations legales).</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">10. Contact</h2>
            <p>Pour toute question : <a href="mailto:info@viralsynth.com" className="text-[#FF3300] hover:underline">info@viralsynth.com</a></p>
          </section>
        </div>
      </main>
      <footer className="border-t border-white/5 mt-16">
        <div className="max-w-4xl mx-auto px-6 py-8 text-center text-xs text-white/30">
          &copy; 2026 ViralSynth. Tous droits reserves. &middot; <Link to="/terms" className="hover:text-white/60">Conditions d'utilisation</Link>
        </div>
      </footer>
    </div>
  );
}
